import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
export var isnan = function isnan(v) {
  return Number.isNaN(v);
};
export var isValidNumber = function isValidNumber(v) {
  return typeof v === 'number' && !Number.isNaN(v);
};
export var TEST_MIN_IF_NOT_NAN = function TEST_MIN_IF_NOT_NAN(value, limit) {
  return !isnan(limit) && (limit < 0 && value <= limit || limit >= 0 && value >= limit);
};
export var VEC_LEN_SQ = function VEC_LEN_SQ() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y;

  return x * x + y * y;
};
export var TEST_MAX_IF_NOT_NAN = function TEST_MAX_IF_NOT_NAN(value, max) {
  return !isnan(max) && (max < 0 && value < max || max >= 0 && value > max);
};
export function fireAfterInterval(method, interval) {
  if (!interval) {
    method();
    return null;
  }

  return setTimeout(function () {
    return method();
  }, interval);
}